<template>
  <div>
    <header>
      <div class="headerLeft">
        <img src="@/assets/images/Rlogo2.svg"/>
      </div>
      <div class="headerRight">
        <div class="headerRightContent">
          <div class="userInfo">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <img v-if="showPortrait" :src="portrait"/>
                <img v-if="!showPortrait" src="@/assets/images/portrait.svg"/>
                <div class="name">
                  <span :title="userName"
                        v-if="userName.slice(0, 3) !== 'wx|' || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{userName}}</span>
                  <span v-if="userName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))"
                        style="height: 18px;width: 100%;font-size: 14px;line-height: 18px;">
                    <ww-open-data
                      v-if="userName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))"
                      type="userName" :openid="userName.slice(3)"></ww-open-data>
                  </span>
                  <span :title="ownerName" class="ownerName">{{ownerName}}</span>
                </div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">{{$t('LanguageLib.InfoLogOut')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="assistant"
               @click="addTab($t('LanguageLib.IMPORT_ASSISTANT'),'/importassistant/importlist','importlist')">
            <i class="iconfont" :title="$t('LanguageLib.IMPORT_ASSISTANT')">&#xe60f;</i>
            <!--<span>{{$t('LanguageLib.IMPORT_ASSISTANT')}}</span>-->
          </div>
          <div class="language">
            <i class="iconfont">&#xe612;</i>
            <el-select v-model="lang" placeholder="简体中文" @change='changlan()'>
              <el-option value="CHS" label="简体中文">
              </el-option>
              <el-option value="ENG" label="English">
              </el-option>
              <el-option value="JP" label="日本語">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </header>
    <div class="mainContent" :class="{ hideSidebar: isCollapse }">
      <div class="mainContentLeft">
        <i class="el-icon-s-fold" @click="contraction(true)" v-show="isCollapse == false"></i>
        <i class="el-icon-s-unfold" @click="contraction(false)" v-show="isCollapse == true"></i>
        <div class="scroll">
          <el-menu :default-active="$route.path" :unique-opened="true" class="el-menu-vertical-demo" @open="handleOpen"
                   @close="handleClose" :collapse="isCollapse">
            <!-- <el-menu-item index="/home" @click="addTab($t('LanguageLib.HOME_PAGE'),'/home','home')">
              <i class="iconfont">&#xe614;</i>
              <span slot="title" :title="$t('LanguageLib.HOME_PAGE')">{{$t('LanguageLib.HOME_PAGE')}}</span>
            </el-menu-item> -->
            <el-submenu index="2">
              <template slot="title">
                <i class="iconfont">&#xe616;</i>
                <span slot="title" :title="$t('LanguageLib.TREE_MENU_BASIC_DATA')">{{$t('LanguageLib.TREE_MENU_BASIC_DATA')}}</span>
              </template>
<!--              &lt;!&ndash;客户关系&ndash;&gt;-->
<!--              <el-menu-item :title="$t('LanguageLib.COSTUMER_RELATION')"-->
<!--                            v-show="$route.path !=='/basicdata/costumerrelation'" index="/basicdata/costumerrelation"-->
<!--                            @click="addTab($t('LanguageLib.COSTUMER_RELATION'),'/basicdata/costumerrelation','costumerrelation')">-->
<!--                {{$t('LanguageLib.COSTUMER_RELATION')}}-->
<!--              </el-menu-item>-->
<!--              <el-menu-item :title="$t('LanguageLib.COSTUMER_RELATION')"-->
<!--                            v-show="$route.path ==='/basicdata/costumerrelation'"-->
<!--                            index="/basicdata/costumerrelation/editcostumerrelation"-->
<!--                            @click="addTab($t('LanguageLib.COSTUMER_RELATION'),'/basicdata/costumerrelation','costumerrelation')">-->
<!--                {{$t('LanguageLib.COSTUMER_RELATION')}}-->
<!--              </el-menu-item>-->
<!--              &lt;!&ndash;字段管理&ndash;&gt;-->
<!--              <el-menu-item :title="$t('LanguageLib.FIELD_MANAGEMENT')"-->
<!--                            v-show="$route.path !=='/basicdata/fieldmanagement'" index="/basicdata/fieldmanagement"-->
<!--                            @click="addTab($t('LanguageLib.FIELD_MANAGEMENT'),'/basicdata/fieldmanagement','costumerrelation')">-->
<!--                {{$t('LanguageLib.FIELD_MANAGEMENT')}}-->
<!--              </el-menu-item>-->
<!--              <el-menu-item :title="$t('LanguageLib.FIELD_MANAGEMENT')"-->
<!--                            v-show="$route.path ==='/basicdata/fieldmanagement'"-->
<!--                            index="/basicdata/costumerrelation/fieldmanagement"-->
<!--                            @click="addTab($t('LanguageLib.FIELD_MANAGEMENT'),'/basicdata/fieldmanagement','costumerrelation')">-->
<!--                {{$t('LanguageLib.FIELD_MANAGEMENT')}}-->
<!--              </el-menu-item>-->
              <!--组织类型-->
              <el-menu-item :title="$t('LanguageLib.ORGANIZATION_TYPE')"
                            v-show="$route.path !== '/basicdata/orgtype/addorgtype'" index="/basicdata/orgtype"
                            @click="addTab($t('LanguageLib.ORGANIZATION_TYPE'),'/basicdata/orgtype','orgtype')">
                {{$t('LanguageLib.ORGANIZATION_TYPE')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.ORGANIZATION_TYPE')"
                            v-show="$route.path === '/basicdata/orgtype/addorgtype'"
                            index="/basicdata/orgtype/addorgtype"
                            @click="addTab($t('LanguageLib.ORGANIZATION_TYPE'),'/basicdata/orgtype','orgtype')">
                {{$t('LanguageLib.ORGANIZATION_TYPE')}}
              </el-menu-item>
              <!--组织结构设定-->
              <el-menu-item :title="$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT')"
                            v-show="$route.path !== '/basicdata/domainsetting/addorg' && $route.path !== '/basicdata/domainsetting/addstore'"
                            index="/basicdata/domainsetting"
                            @click="addTab($t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT'),'/basicdata/domainsetting','domainsetting')">
                {{$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/domainsetting/addorg'"
                            index="/basicdata/domainsetting/addorg"
                            @click="addTab($t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT'),'/basicdata/domainsetting','domainsetting')">
                {{$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/domainsetting/addstore'"
                            index="/basicdata/domainsetting/addstore"
                            @click="addTab($t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT'),'/basicdata/domainsetting','domainsetting')">
                {{$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT')}}
              </el-menu-item>
              <!--角色设定-->
              <el-menu-item :title="$t('LanguageLib.THE_ROLE_OF_SETTING')"
                            v-show="$route.path !== '/basicdata/rolesetting/addrole' && $route.path !== '/basicdata/rolesetting/updateroleauthority'"
                            index="/basicdata/rolesetting"
                            @click="addTab($t('LanguageLib.THE_ROLE_OF_SETTING'),'/basicdata/rolesetting','rolesetting')">
                {{$t('LanguageLib.THE_ROLE_OF_SETTING')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.THE_ROLE_OF_SETTING')"
                            v-show="$route.path === '/basicdata/rolesetting/addrole'"
                            index="/basicdata/rolesetting/addrole"
                            @click="addTab($t('LanguageLib.THE_ROLE_OF_SETTING'),'/basicdata/rolesetting','rolesetting')">
                {{$t('LanguageLib.THE_ROLE_OF_SETTING')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.THE_ROLE_OF_SETTING')"
                            v-show="$route.path === '/basicdata/rolesetting/updateroleauthority'"
                            index="/basicdata/rolesetting/updateroleauthority"
                            @click="addTab($t('LanguageLib.THE_ROLE_OF_SETTING'),'/basicdata/rolesetting','rolesetting')">
                {{$t('LanguageLib.THE_ROLE_OF_SETTING')}}
              </el-menu-item>
              <!--人员管理-->
              <el-menu-item :title="$t('LanguageLib.PERSONNEL_MANAGEMENT')"
                            v-show="$route.path !== '/basicdata/personnelmanagement/position' && $route.path !== '/basicdata/personnelmanagement/addperson'"
                            index="/basicdata/personnelmanagement"
                            @click="addTab($t('LanguageLib.PERSONNEL_MANAGEMENT'),'/basicdata/personnelmanagement','personnelmanagement')">
                {{$t('LanguageLib.PERSONNEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.PERSONNEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/personnelmanagement/position'"
                            index="/basicdata/personnelmanagement/position"
                            @click="addTab($t('LanguageLib.PERSONNEL_MANAGEMENT'),'/basicdata/personnelmanagement','personnelmanagement')">
                {{$t('LanguageLib.PERSONNEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.PERSONNEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/personnelmanagement/addperson'"
                            index="/basicdata/personnelmanagement/addperson"
                            @click="addTab($t('LanguageLib.PERSONNEL_MANAGEMENT'),'/basicdata/personnelmanagement','personnelmanagement')">
                {{$t('LanguageLib.PERSONNEL_MANAGEMENT')}}
              </el-menu-item>
              <!--标签管理-->
              <el-menu-item :title="$t('LanguageLib.LABEL_MANAGEMENT')"
                            v-show="$route.path !== '/basicdata/tagmanagement/addpersontag' && $route.path !== '/basicdata/tagmanagement/addstoretag' && $route.path !== '/basicdata/tagmanagement/personbindrole' && $route.path !== '/basicdata/tagmanagement/aboutperson' && $route.path !== '/basicdata/tagmanagement/aboutstore'"
                            index="/basicdata/tagmanagement"
                            @click="addTab($t('LanguageLib.LABEL_MANAGEMENT'),'/basicdata/tagmanagement','tagmanagement')">
                {{$t('LanguageLib.LABEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.LABEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/tagmanagement/addpersontag'"
                            index="/basicdata/tagmanagement/addpersontag"
                            @click="addTab($t('LanguageLib.LABEL_MANAGEMENT'),'/basicdata/tagmanagement','tagmanagement')">
                {{$t('LanguageLib.LABEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.LABEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/tagmanagement/addstoretag'"
                            index="/basicdata/tagmanagement/addstoretag"
                            @click="addTab($t('LanguageLib.LABEL_MANAGEMENT'),'/basicdata/tagmanagement','tagmanagement')">
                {{$t('LanguageLib.LABEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.LABEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/tagmanagement/personbindrole'"
                            index="/basicdata/tagmanagement/personbindrole"
                            @click="addTab($t('LanguageLib.LABEL_MANAGEMENT'),'/basicdata/tagmanagement','tagmanagement')">
                {{$t('LanguageLib.LABEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.LABEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/tagmanagement/aboutperson'"
                            index="/basicdata/tagmanagement/aboutperson"
                            @click="addTab($t('LanguageLib.LABEL_MANAGEMENT'),'/basicdata/tagmanagement','tagmanagement')">
                {{$t('LanguageLib.LABEL_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.LABEL_MANAGEMENT')"
                            v-show="$route.path === '/basicdata/tagmanagement/aboutstore'"
                            index="/basicdata/tagmanagement/aboutstore"
                            @click="addTab($t('LanguageLib.LABEL_MANAGEMENT'),'/basicdata/tagmanagement','tagmanagement')">
                {{$t('LanguageLib.LABEL_MANAGEMENT')}}
              </el-menu-item>
              <!--导入助手-->
              <!--<el-menu-item :title="$t('LanguageLib.IMPORT_ASSISTANT')" index="/importassistant/importlist" @click="addTab($t('LanguageLib.IMPORT_ASSISTANT'),'/importassistant/importlist','importlist')">{{$t('LanguageLib.IMPORT_ASSISTANT')}}</el-menu-item>-->
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="iconfont">&#xe613;</i>
                <span slot="title" :title="$t('LanguageLib.COMPANY_CONFIGURATION')">{{$t('LanguageLib.COMPANY_CONFIGURATION')}}</span>
              </template>
              <!--基础配置-->
              <el-menu-item :title="$t('LanguageLib.BASIC_CONFIGURATION')" index="/companyallocation/basicconfig"
                            @click="addTab($t('LanguageLib.BASIC_CONFIGURATION'),'/companyallocation/basicconfig','basicconfig')">
                {{$t('LanguageLib.BASIC_CONFIGURATION')}}
              </el-menu-item>
              <!--基本信息-->
              <el-menu-item :title="$t('LanguageLib.BASIC_INFORMATION')" index="/companyallocation/basicinfo"
                            @click="addTab($t('LanguageLib.BASIC_INFORMATION'),'/companyallocation/basicinfo','basicinfo')">
                {{$t('LanguageLib.BASIC_INFORMATION')}}
              </el-menu-item>
              <!-- 店铺字段配置 -->
              <el-menu-item :title="$t('LanguageLib.STORE_FIELD_CONFIGURATION')"
                            index="/companyallocation/storefieldconfig"
                            @click="addTab($t('LanguageLib.STORE_FIELD_CONFIGURATION'),'/companyallocation/storefieldconfig','storefieldconfig')">
                {{$t('LanguageLib.STORE_FIELD_CONFIGURATION')}}
              </el-menu-item>
              <!-- 巡店模板配置 -->
              <el-menu-item v-if="(moduleCode.includes('32')) || (moduleCode.includes('4'))"
                            :title="$t('LanguageLib.SHOP_TEMPLETE_CONFIG')"
                            index="/companyallocation/shoptempleteconfig"
                            @click="addTab($t('LanguageLib.SHOP_TEMPLETE_CONFIG'),'/companyallocation/shoptempleteconfig','shoptempleteconfig')">
                {{$t('LanguageLib.SHOP_TEMPLETE_CONFIG')}}
              </el-menu-item>
              <!--报修模块配置-->
              <el-menu-item v-if="(moduleCode.includes('1'))" :title="$t('LanguageLib.REPAIR_MODULE_CONFIGURATION')"
                            index="/companyallocation/mntmoduleconfig"
                            @click="addTab($t('LanguageLib.REPAIR_MODULE_CONFIGURATION'),'/companyallocation/mntmoduleconfig','mntmoduleconfig')">
                {{$t('LanguageLib.REPAIR_MODULE_CONFIGURATION')}}
              </el-menu-item>
              <!--道具管理配置-->
              <el-menu-item v-if="(moduleCode.includes('41'))" :title="$t('LanguageLib.z_info_common_000045')"
                            index="/companyallocation/propmoduleconfig"
                            @click="addTab($t('LanguageLib.z_info_common_000045'),'/companyallocation/propmoduleconfig','propmoduleconfig')">
                {{$t('LanguageLib.z_info_common_000045')}}
              </el-menu-item>
              <!--邮件配置-->
              <el-menu-item :title="$t('LanguageLib.MAIL_CONFIGURATION')" index="/companyallocation/mailconfig"
                            @click="addTab($t('LanguageLib.MAIL_CONFIGURATION'),'/companyallocation/mailconfig','mailconfig')">
                {{$t('LanguageLib.MAIL_CONFIGURATION')}}
              </el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="iconfont">&#xe60d;</i>
                <span slot="title" :title="$t('LanguageLib.STORE_INFO')">{{$t('LanguageLib.STORE_INFO')}}</span>
              </template>
              <!--店铺管理-->
              <el-menu-item :title="$t('LanguageLib.STORE_MANAGEMENT')"
                            v-show="$route.path !== '/storeinformation/storemanagement/addstore' && $route.path !== '/storeinformation/storemanagement/addtag' && $route.path !== '/storeinformation/storemanagement/upload'"
                            index="/storeinformation/storemanagement"
                            @click="addTab($t('LanguageLib.STORE_MANAGEMENT'),'/storeinformation/storemanagement','storemanagement')">
                {{$t('LanguageLib.STORE_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.STORE_MANAGEMENT')"
                            v-show="$route.path === '/storeinformation/storemanagement/addstore'"
                            index="/storeinformation/storemanagement/addstore"
                            @click="addTab($t('LanguageLib.STORE_MANAGEMENT'),'/storeinformation/storemanagement','storemanagement')">
                {{$t('LanguageLib.STORE_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.STORE_MANAGEMENT')"
                            v-show="$route.path === '/storeinformation/storemanagement/addtag'"
                            index="/storeinformation/storemanagement/addtag"
                            @click="addTab($t('LanguageLib.STORE_MANAGEMENT'),'/storeinformation/storemanagement','storemanagement')">
                {{$t('LanguageLib.STORE_MANAGEMENT')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.STORE_MANAGEMENT')"
                            v-show="$route.path === '/storeinformation/storemanagement/upload'"
                            index="/storeinformation/storemanagement/upload"
                            @click="addTab($t('LanguageLib.STORE_MANAGEMENT'),'/storeinformation/storemanagement','storemanagement')">
                {{$t('LanguageLib.STORE_MANAGEMENT')}}
              </el-menu-item>
              <!--店铺类型-->
              <el-menu-item :title="$t('LanguageLib.SHOP_TYPE')"
                            v-show="$route.path !== '/storeinformation/storetype/addstoretype'"
                            index="/storeinformation/storetype"
                            @click="addTab($t('LanguageLib.SHOP_TYPE'),'/storeinformation/storetype','storetype')">
                {{$t('LanguageLib.SHOP_TYPE')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.SHOP_TYPE')"
                            v-show="$route.path === '/storeinformation/storetype/addstoretype'"
                            index="/storeinformation/storetype/addstoretype"
                            @click="addTab($t('LanguageLib.SHOP_TYPE'),'/storeinformation/storetype','storetype')">
                {{$t('LanguageLib.SHOP_TYPE')}}
              </el-menu-item>
              <!--品牌设定-->
              <el-menu-item :title="$t('LanguageLib.BRAND_SETTINGS')"
                            v-show="$route.path !== '/storeinformation/brandsetting/addbrand'"
                            index="/storeinformation/brandsetting"
                            @click="addTab($t('LanguageLib.BRAND_SETTINGS'),'/storeinformation/brandsetting','brandsetting')">
                {{$t('LanguageLib.BRAND_SETTINGS')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.BRAND_SETTINGS')"
                            v-show="$route.path === '/storeinformation/brandsetting/addbrand'"
                            index="/storeinformation/brandsetting/addbrand"
                            @click="addTab($t('LanguageLib.BRAND_SETTINGS'),'/storeinformation/brandsetting','brandsetting')">
                {{$t('LanguageLib.BRAND_SETTINGS')}}
              </el-menu-item>
<!--              地区设定-->
<!--              <el-menu-item :title="$t('LanguageLib.AREA_SETTING')"-->
<!--                            v-show="$route.path !== '/storeinformation/brandsetting/areasetting'"-->
<!--                            index="/storeinformation/areasetting"-->
<!--                            @click="addTab($t('LanguageLib.AREA_SETTING'),'/storeinformation/areasetting','areasetting','areasetting')">-->
<!--                {{$t('LanguageLib.AREA_SETTING')}}-->
<!--              </el-menu-item>-->
            </el-submenu>
            <el-submenu index="5" v-if="(moduleCode.includes('42'))">
              <template slot="title">
                <i class="iconfont">&#xe615;</i>
                <span slot="title"
                      :title="$t('LanguageLib.DEVICE_MANAGEMENT')">{{$t('LanguageLib.DEVICE_MANAGEMENT')}}</span>
              </template>
              <el-menu-item :title="$t('LanguageLib.MECHANICAL_ARM')"
                            v-show="$route.path !== '/devicemanagement/mechanicalarm/updatamechanicalarm'"
                            index="/devicemanagement/mechanicalarm"
                            @click="addTab($t('LanguageLib.MECHANICAL_ARM'),'/devicemanagement/mechanicalarm','mechanicalarm')">
                {{$t('LanguageLib.MECHANICAL_ARM')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.MECHANICAL_ARM')"
                            v-show="$route.path === '/devicemanagement/mechanicalarm/updatamechanicalarm'"
                            index="/devicemanagement/mechanicalarm/updatamechanicalarm"
                            @click="addTab($t('LanguageLib.MECHANICAL_ARM'),'/devicemanagement/mechanicalarm','mechanicalarm')">
                {{$t('LanguageLib.MECHANICAL_ARM')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.SMART_SCREEN')" index="/devicemanagement/smartscreen"
                            @click="addTab($t('LanguageLib.SMART_SCREEN'), '/devicemanagement/smartscreen', 'smartscreen')">
                {{$t('LanguageLib.SMART_SCREEN')}}
              </el-menu-item>
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">
                <i class="iconfont">&#xe61d;</i>
                <span slot="title" :title="$t('LanguageLib.SHOP_REPAIR1')">{{$t('LanguageLib.SHOP_REPAIR1')}}</span>
              </template>
              <!--维修分类-->
              <el-menu-item :title="$t('LanguageLib.MAINTENANCE_CLASSIFICATION')"
                            v-show="$route.path !== '/storemnt/mntcategory/mntcategorylist'"
                            index="/storemnt/mntcategory"
                            @click="addTab($t('LanguageLib.MAINTENANCE_CLASSIFICATION'),'/storemnt/mntcategory','mntcategory')">
                {{$t('LanguageLib.MAINTENANCE_CLASSIFICATION')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.MAINTENANCE_CLASSIFICATION')"
                            v-show="$route.path === '/storemnt/mntcategory/mntcategorylist'"
                            index="/storemnt/mntcategory/mntcategorylist"
                            @click="addTab($t('LanguageLib.MAINTENANCE_CLASSIFICATION'),'/storemnt/mntcategory','mntcategory')">
                {{$t('LanguageLib.MAINTENANCE_CLASSIFICATION')}}
              </el-menu-item>
              <!--道具分类-->
              <el-menu-item :title="$t('LanguageLib.ITEM_CLASSIFICATION')"
                            v-show="$route.path !== '/storemnt/propcategory/editpropcategory'"
                            index="/storemnt/propcategory"
                            @click="addTab($t('LanguageLib.ITEM_CLASSIFICATION'),'/storemnt/propcategory','propcategory')">
                {{$t('LanguageLib.ITEM_CLASSIFICATION')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.ITEM_CLASSIFICATION')"
                            v-show="$route.path === '/storemnt/propcategory/editpropcategory'"
                            index="/storemnt/propcategory/editpropcategory"
                            @click="addTab($t('LanguageLib.ITEM_CLASSIFICATION'),'/storemnt/propcategory','propcategory')">
                {{$t('LanguageLib.ITEM_CLASSIFICATION')}}
              </el-menu-item>
              <!-- 维修问题-->
              <el-menu-item :title="$t('LanguageLib.MNT_QUESTION')"
                            v-show="$route.path !== '/storemnt/mntquestion/editmntquestion'"
                            index="/storemnt/mntquestion"
                            @click="addTab($t('LanguageLib.MNT_QUESTION'),'/storemnt/mntquestion','mntquestion')">
                {{$t('LanguageLib.MNT_QUESTION')}}
              </el-menu-item>
              <el-menu-item :title="$t('LanguageLib.MNT_QUESTION')"
                            v-show="$route.path === '/storemnt/mntquestion/editmntquestion'"
                            index="/storemnt/mntquestion/editmntquestion"
                            @click="addTab($t('LanguageLib.MNT_QUESTION'),'/storemnt/mntquestion','mntquestion')">
                {{$t('LanguageLib.MNT_QUESTION')}}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="mainContentRight">
        <div class="container">
          <el-tabs v-model="TabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab"
                   @edit="editTab">
            <el-tab-pane
              v-for="item in Tabs"
              :key="item.title"
              :label="item.title"
              :name="item.title"
              :index="item.index"
              :topath="item.topath"
              :keys="item.keys"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeapi from '../api/home'

export default {
  data () {
    return {
      moduleCode: JSON.parse(this.$commonfun.localStorage.getitem('moduleCode')), // 模块购买
      lang: window.localStorage.getItem('lang'), // 语言类型
      userName: window.localStorage.getItem('userName'), // 用户名
      ownerName: window.localStorage.getItem('ownerName'), // 公司名
      portrait: window.localStorage.getItem('portrait'), // 用户头像
      showPortrait: window.localStorage.getItem('portrait') !== '', // 是否显示占位图
      isCollapse: false,
      TabsValue: this.$t('LanguageLib.PERSONNEL_MANAGEMENT'),
      Tabs: [
        {
          title: this.$t('LanguageLib.PERSONNEL_MANAGEMENT'),
          topath: '/basicdata/personnelmanagement',
          keys: 'personnelmanagement'
        }
      ],
      updataRouteQuery: (navisshow) => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.NoRefresh = true
        newQuery.navisshow = navisshow
        this.$router.push({
          path,
          query: newQuery
        })
      }
    }
  },
  methods: {
    // header头部
    handleCommand (command) {
      // 退出登录
      if (command === 'a') {
        // this.$commonfun.localStorage.clearall()
        this.$commonfun.localStorage.removeitem('routekey')
        this.$commonfun.localStorage.removeitem('ownerId')
        this.$commonfun.localStorage.removeitem('ownerCode')
        this.$commonfun.localStorage.removeitem('userId')
        this.$commonfun.localStorage.removeitem('sid')
        this.$commonfun.localStorage.removeitem('token')
        this.$commonfun.localStorage.removeitem('userName')
        this.$commonfun.localStorage.removeitem('ownerName')
        this.$commonfun.localStorage.removeitem('OwnerLanguage')
        this.$commonfun.localStorage.removeitem('qyuser')
        this.$commonfun.localStorage.removeitem('portrait')
        this.$commonfun.localStorage.removeitem('loginstatus')
        this.$commonfun.localStorage.removeitem('title')
        this.$commonfun.localStorage.removeitem('topath')
        this.$commonfun.localStorage.removeitem('keys')
        this.$commonfun.localStorage.removeitem('moduleCode')
        this.$commonfun.localStorage.setitem('loginstatus', false)
        this.$router.push('/login')
      }
    },
    changlan () {
      this.$commonfun.localStorage.setitem('lang', this.lang)
      //    if (this.lang === 'CHS') {
      //      this.$i18n.locale = 'zh'//  切换语言
      //    }
      //    if (this.lang === 'ENG') {
      //      this.$i18n.locale = 'en'//  切换语言
      //    }
      //    if (this.lang === 'JP') {
      //      this.$i18n.locale = 'jp'//  切换语言
      //    }
      this.$router.go(0)
    },
    // sideBar&内容区
    getList () {
      homeapi.getjson('get', '/musicRankings').then(res => this.$commonfun.console.log(res)).catch(err => this.$commonfun.console.log(err))
    },
    handleOpen (key, keyPath) {
      this.$commonfun.console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      this.$commonfun.console.log(key, keyPath)
    },
    // 展开收起导航栏
    contraction (type) {
      this.$commonfun.console.log(type)
      this.isCollapse = type
      this.updataRouteQuery(type)
    },
    // 点击导航菜单
    addTab (title, topath, keys) {
      if (topath !== '/basicdata/personnelmanagement') {
        this.$commonfun.localStorage.setitem('title', title)
        this.$commonfun.localStorage.setitem('topath', topath)
        this.$commonfun.localStorage.setitem('keys', keys)
      } else {
        this.$commonfun.localStorage.removeitem('title')
        this.$commonfun.localStorage.removeitem('topath')
        this.$commonfun.localStorage.removeitem('keys')
      }
      var exist = false
      for (var i = 0; i < this.Tabs.length; i++) {
        if (title === this.Tabs[i].title) {
          exist = true
          break
        }
      }
      if (exist === true) {
        this.TabsValue = title
        // 路由跳转
        if (this.$route.path === topath) {
        } else {
          this.$router.push({
            path: topath,
            query: { navisshow: this.isCollapse }
          })
        }
        return
      }
      this.Tabs.push({
        title: title,
        topath: topath,
        keys: keys
      })
      this.TabsValue = title
      // 路由跳转
      if (this.$route.path === topath) {
      } else {
        this.$router.push({
          path: topath,
          query: { navisshow: this.isCollapse }
        })
      }
    },
    // 移出标签页tab
    removeTab (targetName) {
      const tabs = this.Tabs
      let activeName = this.TabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.title === targetName) {
            var nextTab
            if (index === tabs.length - 1) {
              nextTab = tabs[tabs.length - 2]
            } else {
              nextTab = tabs[tabs.length - 1] || tabs[index - 1]
            }
            if (nextTab) {
              activeName = nextTab.title
              if (nextTab.topath !== '/basicdata/personnelmanagement') {
                this.$commonfun.localStorage.setitem('title', nextTab.title)
                this.$commonfun.localStorage.setitem('topath', nextTab.topath)
                this.$commonfun.localStorage.setitem('keys', nextTab.keys)
              } else {
                this.$commonfun.localStorage.removeitem('title')
                this.$commonfun.localStorage.removeitem('topath')
                this.$commonfun.localStorage.removeitem('keys')
              }
            }
          }
        })
      }
      this.TabsValue = activeName
      this.Tabs = tabs.filter(tab => tab.title !== targetName)
    },
    // 选中标签页tab的时候和导航做联动
    clickTab (targetName) {
      // 路由跳转
      if (this.$route.path === targetName.$attrs.topath) {
      } else {
        this.$router.push({
          path: targetName.$attrs.topath,
          query: { navisshow: this.isCollapse }
        })
      }
      if (targetName.$attrs.topath !== '/basicdata/personnelmanagement') {
        this.$commonfun.localStorage.setitem('title', targetName.name)
        this.$commonfun.localStorage.setitem('topath', targetName.$attrs.topath)
        this.$commonfun.localStorage.setitem('keys', targetName.$attrs.keys)
      } else {
        this.$commonfun.localStorage.removeitem('title')
        this.$commonfun.localStorage.removeitem('topath')
        this.$commonfun.localStorage.removeitem('keys')
      }
    },
    // 关闭标签
    editTab (targetName, action) {
      // 判断当前显示的标签是不是最后一个标签
      if (this.$route.path.indexOf(this.Tabs[this.Tabs.length - 1].topath) !== -1) {
        // 判断当前所要关闭的标签是不是是最后一个标签
        if (targetName === this.Tabs[this.Tabs.length - 1].title) {
          // 如果是的最后一个路由往前跳一个
          this.$router.push({
            path: this.Tabs[this.Tabs.length - 2].topath,
            query: { navisshow: this.isCollapse }
          })
        }
      } else {
        for (var i = 0; i < this.Tabs.length; i++) {
          // 判断关闭的是哪一个标签
          if (targetName === this.Tabs[i].title) {
            // 如果路由是当前
            if (this.$route.path.indexOf(this.Tabs[i].topath) !== -1) {
              this.$router.push({
                path: this.Tabs[this.Tabs.length - 1].topath,
                query: { navisshow: this.isCollapse }
              })
            }
          }
        }
      }
    }
  },
  watch: {
    $route (to, from) {
      this.updataRouteQuery(this.isCollapse)
      for (let i = 0; i < this.Tabs.length; i++) {
        if (to.path.indexOf(this.Tabs[i].topath) !== -1) {
          this.TabsValue = this.Tabs[i].title
        }
      }
    }
  },
  created () {
    // header头部
    this.lang = this.$commonfun.localStorage.getitem('lang') ? this.$commonfun.localStorage.getitem('lang') : 'CHS'
    if (this.lang === 'CHS') {
      this.$i18n.locale = 'zh'//  切换语言
    }
    if (this.lang === 'ENG') {
      this.$i18n.locale = 'en'//  切换语言
    }
    if (this.lang === 'JP') {
      this.$i18n.locale = 'jp'//  切换语言
    }
    this.Tabs[0].title = this.$t('LanguageLib.PERSONNEL_MANAGEMENT')
    // sideBar&内容区
    this.updataRouteQuery(false)
    if (this.$commonfun.localStorage.getitem('keys') !== null) {
      switch (this.$commonfun.localStorage.getitem('keys')) {
        case 'home':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.HOME_PAGE'))
          this.Tabs.push({
            title: this.$t('LanguageLib.HOME_PAGE'),
            topath: '/home',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'domainsetting':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT'))
          this.Tabs.push({
            title: this.$t('LanguageLib.TREE_MENU_DOMAIN_MANAGEMENT'),
            topath: '/basicdata/domainsetting',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'personnelmanagement':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.PERSONNEL_MANAGEMENT'))
          this.Tabs.push({
            title: this.$t('LanguageLib.PERSONNEL_MANAGEMENT'),
            topath: '/basicdata/personnelmanagement',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'tagmanagement':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.LABEL_MANAGEMENT'))
          this.Tabs.push({
            title: this.$t('LanguageLib.LABEL_MANAGEMENT'),
            topath: '/basicdata/tagmanagement',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'orgtype':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.ORGANIZATION_TYPE'))
          this.Tabs.push({
            title: this.$t('LanguageLib.ORGANIZATION_TYPE'),
            topath: '/basicdata/orgtype',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'rolesetting':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.THE_ROLE_OF_SETTING'))
          this.Tabs.push({
            title: this.$t('LanguageLib.THE_ROLE_OF_SETTING'),
            topath: '/basicdata/rolesetting',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'storemanagement':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.STORE_MANAGEMENT'))
          this.Tabs.push({
            title: this.$t('LanguageLib.STORE_MANAGEMENT'),
            topath: '/storeinformation/storemanagement',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'storetype':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.SHOP_TYPE'))
          this.Tabs.push({
            title: this.$t('LanguageLib.SHOP_TYPE'),
            topath: '/storeinformation/storetype',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'mechanicalarm':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.MECHANICAL_ARM'))
          this.Tabs.push({
            title: this.$t('LanguageLib.MECHANICAL_ARM'),
            topath: '/devicemanagement/mechanicalarm',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'smartscreen':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.SMART_SCREEN'))
          this.Tabs.push({
            title: this.$t('LanguageLib.SMART_SCREEN'),
            topath: '/devicemanagement/smartscreen',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'importlist':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.IMPORT_ASSISTANT'))
          this.Tabs.push({
            title: this.$t('LanguageLib.IMPORT_ASSISTANT'),
            topath: '/importassistant/importlist',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'basicconfig':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.BASIC_CONFIGURATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.BASIC_CONFIGURATION'),
            topath: '/companyallocation/basicconfig',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'shoptempleteconfig':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.SHOP_TEMPLETE_CONFIG'))
          this.Tabs.push({
            title: this.$t('LanguageLib.SHOP_TEMPLETE_CONFIG'),
            topath: '/companyallocation/shoptempleteconfig',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'storefieldconfig':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.STORE_FIELD_CONFIGURATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.STORE_FIELD_CONFIGURATION'),
            topath: '/companyallocation/storefieldconfig',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'basicinfo':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.BASIC_INFORMATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.BASIC_INFORMATION'),
            topath: '/companyallocation/basicinfo',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'brandsetting':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.BRAND_SETTINGS'))
          this.Tabs.push({
            title: this.$t('LanguageLib.BRAND_SETTINGS'),
            topath: '/storeinformation/brandsetting',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'mntcategory':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.MAINTENANCE_CLASSIFICATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.MAINTENANCE_CLASSIFICATION'),
            topath: '/storemnt/mntcategory',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'propcategory':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.ITEM_CLASSIFICATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.ITEM_CLASSIFICATION'),
            topath: '/storemnt/propcategory',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'mntquestion':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.MNT_QUESTION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.MNT_QUESTION'),
            topath: '/storemnt/mntquestion',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'mntmoduleconfig':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.REPAIR_MODULE_CONFIGURATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.REPAIR_MODULE_CONFIGURATION'),
            topath: '/companyallocation/mntmoduleconfig',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'propmoduleconfig':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.z_info_common_000045'))
          this.Tabs.push({
            title: this.$t('LanguageLib.z_info_common_000045'),
            topath: '/companyallocation/propmoduleconfig',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
        case 'mailconfig':
          this.$commonfun.localStorage.setitem('title', this.$t('LanguageLib.MAIL_CONFIGURATION'))
          this.Tabs.push({
            title: this.$t('LanguageLib.MAIL_CONFIGURATION'),
            topath: '/companyallocation/mailconfig',
            keys: this.$commonfun.localStorage.getitem('keys')
          })
          break
      }
      this.$router.push({
        path: this.$commonfun.localStorage.getitem('topath'),
        query: JSON.parse(this.$commonfun.localStorage.getitem('toquery'))
      })
      this.updataRouteQuery(this.isCollapse)
      this.TabsValue = this.Tabs[this.Tabs.length - 1].title
    } else {
      this.TabsValue = this.Tabs[0].title
    }
  }
}
</script>
<style lang="scss">
  header {
    height: 60px;
    width: 100%;
    min-width: 1280px;
    position: fixed;
    top: 0;

    .headerLeft {
      height: 100%;
      width: 160px;
      float: left;

      img {
        height: 100%;
      }
    }

    .headerRight {
      height: 100%;
      width: calc(100% - 160px);
      float: left;

      .headerRightContent {
        height: 100%;
        overflow: hidden;
        /*width: 500px;*/
        padding-right: 50px;
        float: right;

        .language {
          height: 40px;
          border: none;
          border-radius: 0;
          width: 100px;
          font-size: 12px;
          margin-top: 10px;
          /*border-left: 1px solid #C9C9C9;*/
          float: left;
          position: relative;
          padding-left: 20px;

          .iconfont {
            position: absolute;
            top: 10px;
            left: 10px;
            font-size: 19px;
            color: #666;
          }

          input {
            background: none;
            border: 0;
          }
        }

        .userInfo {
          float: left;
          /*width: 240px;*/
          padding-right: 10px;
          height: 40px;
          margin-top: 10px;
          display: flex;
          align-items: center;
          padding-left: 10px;
          cursor: pointer;
          border-right: 1px solid #C9C9C9;

          .el-icon--right {
            margin-top: 9px;
            margin-left: 10px;
            color: #C0C4CC;
            font-size: 14px;
          }

          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            float: left;
          }

          .name {
            float: left;
            padding-left: 5px;
            position: relative;

            span {
              display: block;
              text-align: left;
              white-space: nowrap;
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            span:nth-of-type(1) {
              font-size: 14px;
            }

            .ownerName {
              font-size: 12px;
            }
          }
        }

        .assistant {
          float: left;
          height: 40px;
          margin-top: 10px;
          padding: 0 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          border-right: 1px solid #C9C9C9;

          i {
            font-size: 19px;
            color: #666;
          }

          span {
            font-size: 12px;
            margin-left: 3px;
          }
        }

        .logout {
          float: left;
          height: 100%;
          padding-left: 5px;
          display: flex;
          align-items: center;

          i {
            font-size: 19px;
            font-weight: 600;
            color: #666;
          }

          span {
            font-size: 12px;
            margin-left: 3px;
          }
        }
      }
    }
  }

  .mainContent {
    width: 100%;
    min-width: 1280px;
    padding-top: 60px;
    height: 51px;

    .mainContentLeft {
      height: 100%;
      background: #414141;
      float: left;
      position: fixed;
      z-index: 999;
      overflow: hidden;
      text-align: left;

      .el-icon-s-fold, .el-icon-s-unfold {
        color: #fff;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        margin-left: 20px;
      }

      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 160px;
      }
    }

    .mainContentRight {
      width: 100%;
      height: 100%;
      text-align: left;
      transition: padding-left .28s;
      padding-left: 160px;
      position: fixed;
      top: 60px;
      height: 51px;
      background: #F2F2F2;

      .container {
        padding: 10px 20px 0 10px;
        /*height: calc( 100% - 40px );*/
      }
    }
  }

  .hideSidebar {
    .mainContentRight {
      padding-left: 64px;
    }
  }

  .el-menu {
    background-color: transparent !important;
  }

  .el-submenu .el-menu-item {
    min-width: 0;
  }

  .el-submenu__title {
    color: #fff;

    i {
      color: #fff;
    }

    .el-submenu__icon-arrow {
      top: 30px;
    }

    span {
      overflow: hidden;
      display: inline-block;
      max-width: 75px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .scroll {
    overflow-y: scroll;
    margin-bottom: -17px;
    margin-right: -18px;
    height: calc(100% - 110px);
  }

  .el-menu-item {
    color: #fff;
    max-width: 160px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 10px !important;
  }

  .el-menu-item.is-active {
    color: #3BC6B9;
  }

  .el-menu-item:focus, .el-menu-item:hover {
    background-color: #353535 !important;
  }

  .el-submenu__title:hover {
    background-color: #353535 !important;
  }

  .el-tabs__header {
    margin: 0;
  }

  .routerView {
    height: calc(100% - 40px);
    background: #fff;
  }

  .el-menu--inline {
    li {
      padding-left: 48px !important;
    }
  }

  .el-tabs__nav .el-tabs__item:nth-child(1) span {
    display: none;
  }

  .el-tabs__item {
    background: #fff !important;
  }

  .el-tabs__nav .is-active {
    color: #3BC6B9;
  }

  .el-tabs__item:hover {
    color: #3BC6B9;
  }

  .el-menu-item .el-icon-s-home {
    color: #fff;
  }

  // 导航栏收起时鼠标移上去样式
  .el-menu--vertical {
    background: #414141;

    ul {
      padding: 0;
    }
  }

  .el-tooltip__popper.is-dark {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border: 1px solid #E4E7ED;
    background-color: #414141;
    color: #fff;

    .popper__arrow {
      border-top-color: #E4E7ED;
    }

    .popper__arrow::after {
      border-top-color: transparent;
      border-right-color: #414141;
    }
  }

  .el-dropdown-menu__item:hover {
    background: #f5f7fa !important;
    color: #666 !important;
  }

  .el-tabs__nav-scroll {
    .el-icon-close {
      position: absolute !important;
      top: 13px !important;
      right: 5px !important;
      width: 14px;
      display: none;
    }

    .is-active {
      .el-icon-close {
        display: block;
      }
    }

    .el-icon-close:hover {
      color: #fff !important;
      transition: color 0s;
    }
  }

  .el-tabs__item {
    padding: 0 20px !important;
  }

  .el-tabs__item.is-closable:hover .el-icon-close {
    display: block;
    color: #3BC6B9;
  }

  .el-tabs__item.is-closable:nth-of-type(1):hover .el-icon-close {
    display: none;
  }

  .el-menu-item .iconfont {
    margin-left: 4px;
    vertical-align: middle;
    margin-right: 8px;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }

  .el-submenu__title .iconfont {
    margin-left: 4px;
    vertical-align: middle;
    margin-right: 8px;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }

  .el-menu-item #homeicon {
    color: #fff;
  }

  .el-menu-item.is-active #homeicon {
    color: #3BC6B9;
  }

</style>
